import { render, staticRenderFns } from "./viewMetaDataList.vue?vue&type=template&id=3dbfaaa3&"
import script from "./viewMetaDataList.vue?vue&type=script&lang=js&"
export * from "./viewMetaDataList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports